import theme from '../../base';

const heading = {
  foreground: theme.colors.neutrals.gray800,
};

export default heading;
